import { render, staticRenderFns } from "./WDDateStatus.vue?vue&type=template&id=691a62f1&"
import script from "./WDDateStatus.vue?vue&type=script&lang=js&"
export * from "./WDDateStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports